<!--新建充值记录组件-->
<template>
  <a-modal
    title="新建充值"
    :width="640"
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    class="new-recharge-dialog"
    @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="充值金额" prop="amount">
        <a-input
          v-model="ruleForm.amount"
          placeholder="请输入0-1000000数值"
          style="width: 320px"
        />
      </a-form-model-item>

      <a-form-model-item label="上传充值凭证" prop="voucherImg">
        <a-upload
          :action="uploadFileUrl"
          :accept="acceptTypes"
          :file-list="fileList"
          list-type="picture-card"
          :multiple="true"
          :before-upload="beforeUpload"
          @change="handleUploadChange"
          @remove="handleRemove"
          @preview="handlePreview"
        >
          <div>
            <a-icon type="plus"/>
            <div class="upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <div class="file-tips">支持扩展名：.png .jpg .jpeg .heic .heif</div>
    </a-form-model>

    <div class="dialog-footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</a-button>
    </div>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="充值凭证" style="width: 100%" :src="previewImage"/>
    </a-modal>
  </a-modal>
</template>

<script>
export default {
  name: 'NewRechargeRequest',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    submitPromise: {
      type: Function,
      default: undefined
    }
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        callback(new Error('请输入充值金额'))
        return
      }
      if (!/^\d+(\.\d{1,2})?$/.test(String(value))) {
        callback(new Error('请输入正确金额'))
        return
      }
      if (Number(value) > 1000000) {
        callback(new Error('充值金额不能大于1000000'))
        return
      }
      callback()
    }
    const validateVoucher = (rule, value, callback) => {
      if (!value || !value.length) {
        callback(new Error('请上传充值凭证'))
        return
      }
      callback()
    }

    return {
      uploadFileUrl: this.getUploadFileUrl(),
      acceptTypes: '.png,.jpg,.jpeg,.heic,.heif',
      fileList: [],
      previewVisible: false,
      previewImage: '',
      submitLoading: false,
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      ruleForm: {
        amount: '',
        voucherImg: '',
        voucherImgList: []
      },
      rules: {
        amount: [
          { required: true, validator: validateAmount, trigger: 'blur' }
        ],
        voucherImg: [
          { required: true, validator: validateVoucher, trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    getUploadFileUrl() {
      const appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    beforeUpload(file) {
      const fileName = file.name || ''
      const suffix = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      const isAccept = ['.png', '.jpg', '.jpeg', '.heic', '.heif'].indexOf(suffix) > -1

      if (!isAccept) {
        this.$message.error('上传文件只能是 png、jpg、jpeg、heic、heif 格式')
      }

      return isAccept
    },
    handleUploadChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map(file => {
        const url = this.getUploadResponseUrl(file)
        if (url) {
          file.url = url
        }
        return file
      })

      this.fileList = fileList
      this.updateVoucherImg()

      if (info.file.status === 'done') {
        this.updateVoucherImg()
        this.$refs.ruleForm.validateField('voucherImg')
        this.$message.success('上传成功')
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.updateVoucherImg()
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField('voucherImg')
      })
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    getUploadResponseUrl(file) {
      if (!file) {
        return ''
      }
      if (file.url) {
        return file.url
      }
      const response = file.response
      if (!response) {
        return ''
      }
      if (typeof response === 'string') {
        return response
      }
      if (typeof response.data === 'string') {
        return response.data
      }
      if (response.data && typeof response.data.url === 'string') {
        return response.data.url
      }
      if (typeof response.url === 'string') {
        return response.url
      }
      return ''
    },
    updateVoucherImg() {
      const voucherImgList = this.fileList
        .filter(file => file.status === 'done' || file.url)
        .map(file => this.getUploadResponseUrl(file))
        .filter(Boolean)

      this.ruleForm.voucherImgList = voucherImgList
      this.ruleForm.voucherImg = voucherImgList.join(',')
    },
    hasUploadingFile() {
      return this.fileList.some(file => {
        return file.status === 'uploading' || (!file.status && !this.getUploadResponseUrl(file))
      })
    },
    checkSubmitParams() {
      this.updateVoucherImg()
      if (this.hasUploadingFile()) {
        this.$message.warning('文件上传中，请稍后再提交')
        return false
      }
      if (!this.ruleForm.amount) {
        this.$message.error('充值金额不能为空')
        return false
      }
      if (!this.ruleForm.voucherImg) {
        this.$message.error('充值凭证不能为空')
        return false
      }
      return true
    },
    getSubmitParams() {
      return {
        amount: Number(String(this.ruleForm.amount).trim()),
        voucherImg: this.ruleForm.voucherImg
      }
    },
    handleSubmit() {
      if (!this.checkSubmitParams()) {
        return
      }

      this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          return
        }

        if (this.submitPromise) {
          this.submitLoading = true
          this.submitPromise(this.getSubmitParams())
            .then(() => {
              this.$message.success('新建充值成功')
              this.$emit('success')
              this.handleCancel()
            })
            .catch(reason => this.showNetWorkErrorMessage(reason))
            .finally(() => {
              this.submitLoading = false
            })
          return
        }

        this.$emit('submit', this.getSubmitParams())
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    resetForm() {
      this.fileList = []
      this.previewVisible = false
      this.previewImage = ''
      this.ruleForm = {
        amount: '',
        voucherImg: '',
        voucherImgList: []
      }
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.new-recharge-dialog {
  /deep/ .ant-modal-body {
    height: 270px;
    padding: 30px 80px 72px;
    position: relative;
  }

  /deep/ .ant-form-item {
    margin-bottom: 22px;
  }

  /deep/ .ant-upload.ant-upload-select-picture-card,
  /deep/ .ant-upload-list-picture-card .ant-upload-list-item {
    width: 104px;
    height: 104px;
  }

  .upload-text {
    margin-top: 8px;
    color: #666;
  }

  .file-tips {
    margin-left: 132px;
    color: #999;
  }

  .dialog-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 56px;
    padding: 12px 22px;
    text-align: right;
    border-top: 1px solid #e8e8e8;
    background: #fff;

    .ant-btn + .ant-btn {
      margin-left: 8px;
    }
  }
}
</style>
